<template>
  <a-upload
    name="avatar"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    :before-upload="beforeUpload"
  >
    <img
      style="width: 100%; height: 100%;"
      v-if="innerImageUrl"
      :src="innerImageUrl"
      alt="图片"
    />
    <img
      style="width: 100%; height: 100%;"
      v-else-if="imageUrl"
      :src="imageUrl"
      alt="图片"
    />
    <div v-else>
      <a-icon type="plus" />
      <div class="ant-upload-text">
        上传图片
      </div>
    </div>
  </a-upload>
</template>

<script>
import { getBase64 } from '@/utils/util'

export default {
  props: {
    imageUrl: {
      type: String,
      default: null
    },
    value: {
      type: File,
      default: null
    },
    max: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      innerImageUrl: null,
      file: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    value(val) {
      this.file = JSON.parse(JSON.stringify(val))
      if (val) {
        getBase64(val, imageUrl => {
          this.innerImageUrl = imageUrl
        })
      } else {
        this.innerImageUrl = null
      }
    }
  },
  methods: {
    beforeUpload(file) {
      let { max } = this
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传jpg或png格式图片!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < max
      if (!isLt2M) {
        this.$message.error(`图片必须小于 ${max} MB!`)
        return false
      }
      this.$emit('input', file)
      return false
    }
  }
}
</script>

<style></style>
